import { Component, ElementRef, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ToastService } from '@app/services/toast.service';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
interface Slides {
  image: string;
  title: string;
  description: string;
}
@Component({
  selector: 'app-verifypassword',
  templateUrl: './verifypassword.component.html',
  styleUrl: './verifypassword.component.scss'
})
export class VerifypasswordComponent implements AfterViewInit {
  @ViewChild('sliderWrapper') sliderWrapper!: ElementRef;

  loginForm!: FormGroup;
  submitted = false;
  showPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  loading = false;

  // Slider properties
  slides: Slides[] = [
    {
      image: '../../../../assets/images/banner_1.png',
      title: 'Track Every Delivery',
      description: 'Real-time GPS tracking for complete visibility'
    },
    {
      image: '../../../../assets/images/banner_2.png',
      title: 'Optimize Routes',
      description: 'AI-powered routing for faster deliveries'
    },
    {
      image: '../../../../assets/images/banner_3.png',
      title: 'Smart Analytics',
      description: 'Make data-driven decisions with insights'
    },
    {
      image: '../../../../assets/images/banner_4.png',
      title: 'Happy Customers',
      description: 'Deliver exceptional service every time'
    },
    {
      image: '../../../../assets/images/banner_5.png',
      title: 'Seamless Management',
      description: 'Centralized control for your entire fleet'
    }
  ];
  currentSlide = 0;
  slideInterval: any;
  isTransitioning = false;

  // Touch/Swipe
  touchStartX = 0;
  touchEndX = 0;
  progress = 0;
  // Mouse drag
  isDragging = false;
  dragStartX = 0;
  orgEmail: any;
  constructor(private fb: FormBuilder, private router: Router, private authService: AuthServiceService, private toastr: ToastrService, private toast: ToastService, private sharedData: ShareddtaService, private location: Location) { }

  ngAfterViewInit(): void {
    this.sharedData.signalPageReady();
  }

  ngOnInit(): void {
    // Initialize login form
    this.loginForm = this.fb.group(
      {
        enterpassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmpassword: ['', [Validators.required, Validators.minLength(6)]],
      },
      {
        validators: this.passwordMatchValidator
      }
    );
    this.orgEmail = this.authService.getOrgEmail;

    // Start slider
    this.showSlide(0);
    this.startSlider();
    localStorage.setItem('isLoggedIn', 'false')
  }
  // 🔴 Custom Validator
  passwordMatchValidator(control: AbstractControl) {
    const password = control.get('enterpassword')?.value;
    const confirmPassword = control.get('confirmpassword')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      return { passwordMismatch: true };
    }
    return null;
  }
  get passwordMismatch() {
    return (
      this.loginForm.errors?.['passwordMismatch'] &&
      this.loginForm.get('confirmpassword')?.touched
    );
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.loginForm.invalid) {
      console.log('Form invalid');
      document.getElementById('email')?.focus();
      return;
    }

    this.loading = true;
    const password = this.loginForm.get('enterpassword')?.value;

    // if (!password) {
    //   this.toastr.error('Password is required');
    //   return;
    // }

    this.authService
      .resetPassword(this.orgEmail, password)
      .subscribe({
        next: (data: any) => {
          this.loading = false;
          if (this.authService.resultCodeError(data)) {
            return;
          }
          this.toast.show('success', data?.message);
          this.router.navigate(['/']);
        },
        error: (error) => {
          this.loading = false;
          this.authService.dataError(error);
        }
      });

    //  console.log('Email:', this.loginForm.value.email);
    //  this.router.navigate(['']);
  }

  // ---------------- Slider Methods ----------------

  showSlide(index: number, direction: 'next' | 'prev' = 'next') {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.progressInterval = setInterval(() => {
      this.progress += 2; // 100 / 50 steps = 2%

      if (this.progress >= 100) {
        this.progress = 100;
        clearInterval(this.progressInterval);
      }
    }, 100); //
    const prevIndex = this.currentSlide;
    this.currentSlide = index;

    setTimeout(() => {
      this.isTransitioning = false;
    }, 800);
  }

  nextSlide() {
    this.showSlide((this.currentSlide + 1) % this.slides.length, 'next');
    this.resetSlider();
  }

  prevSlide() {
    this.showSlide(
      (this.currentSlide - 1 + this.slides.length) % this.slides.length,
      'prev'
    );
    this.resetSlider();
  }
  progressInterval: any;
  startSlider() {
    clearInterval(this.slideInterval);
    this.slideInterval = setInterval(() => this.nextSlide(), 5000);
  }

  resetSlider() {
    clearInterval(this.slideInterval);
    this.startSlider();
  }

  // ---------------- Touch / Drag ----------------

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipe();
  }

  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.dragStartX = event.clientX;
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
  }

  onMouseUp(event: MouseEvent) {
    if (!this.isDragging) return;
    this.isDragging = false;

    const diff = this.dragStartX - event.clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) this.nextSlide();
      else this.prevSlide();
      this.resetSlider();
    }
  }

  onMouseLeave() {
    this.isDragging = false;
  }

  handleSwipe() {
    const diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) this.nextSlide();
      else this.prevSlide();
      this.resetSlider();
    }
  }

  // ---------------- Keyboard ----------------
  @HostListener('document:keydown', ['$event'])
  handleKeyboard(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') this.prevSlide();
    else if (event.key === 'ArrowRight') this.nextSlide();
  }

  // ---------------- Pause on Hover ----------------
  onMouseEnter() {
    clearInterval(this.slideInterval);
  }

  onMouseLeaveWrapper() {
    this.startSlider();
  }


  onKeyDown(event: KeyboardEvent) {
    this.submitted = false;
  }

  goBack() {
    this.location.back();
  }

  loginwithotp() {
    this.router.navigate(['/otp-verification']);
  }
  forgotpassword() {
    this.router.navigate(['/forgot-password']);
  }

  // ========== PASSWORD VISIBILITY TOGGLE ==========
  toggleNewPassword(): void {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPassword(): void {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

}

